import Button from "@elements/button";
import { useAcceptCookies } from "@hooks/useAcceptCookies";
import cn from "classnames";
import { useEffect, useState } from "react";

interface Props {
    className?: string;
    title: string;
    description?: string;
    action?: React.ReactNode;
}

const CookieBanner: React.FC<Props> = ({ title }) => {
    const { acceptedCookies, onAcceptCookies } = useAcceptCookies();
    // to prevent hydration mismatch and force the component to rerender on client side
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    }, []);
    return (
        <div className={cn(" max-w-[1240px] mx-auto w-full  sm:flex-row flex-col  flex items-center px-5 py-3 justify-between ", { "hidden": acceptedCookies || !isMounted })}>
            <p className=" font-bold text-sm flex-1 sm:mb-0 mb-2 text-[#333] sm:text-left text-center leading-7">{title}</p>
            <Button className="mx-5 px-2 rounded-lg font-bold text-sm" onClick={onAcceptCookies}>
                Accept cookies
            </Button>
        </div>
    );
};

export default CookieBanner;
